<template>
    <div class="support-container">
        <div class="page-header">
            <h2>{{ lang.supportPage }}</h2>
            <div class="underline"></div>
        </div>
        
        <div class="download-section">
            <div v-for="item in allProductsList" :key="item.name" class="product-category">
                <div class="category-header">
                    <h3>{{ item.name }}</h3>
                </div>
                
                <div class="file-grid">
                    <div v-for="file in item.fileList" :key="file.filename" class="file-card">
                        <div class="file-icon">
                            <i class="el-icon-document"></i>
                        </div>
                        <div class="file-info">
                            <h4 class="file-name">{{ file.filename }}</h4>
                            <button class="download-btn" @click="downloadFile(file.url, file.filename)">
                                <i class="el-icon-download"></i>
                                <span>{{ lang.download }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    mixins: [],
    name: "supportPage",
    components: {},
    computed: {
        currentLanguage() {
            return this.$store.state.language.currentLanguage;
        },
        lang() {
            return this.$store.state.language;
        },
    },
    data() {
        return {
            allProductsList: {},
        };
    },
    created() {
        this.allProductsList = [
            {
                name: "SCORPIO4",
                fileList: [
                    { url: "download/SCP4-CN.pdf", filename: "四光吊舱产品规格书-中文版.pdf" },
                    {
                        url: "download/SCP4-EN.pdf",
                        filename: "Four-light gimbal product specification sheet - English version.pdf",
                    },
                    {
                        url: "download/GEMINI40T-EN.pdf",
                        filename: "GEMINI40 USER MANUAL.pdf",
                    },
                    {
                        url: "download/GEMINI40T-CN.pdf",
                        filename: "GEMINI40用户手册-中文版.pdf",
                    },
                ],
            },
        ];
    },
    async beforeMount() {},
    mounted() {},
    methods: {
        downloadFile(url, filename) {
            const link = document.createElement("a");
            link.href = url;
            link.download = filename;
            console.log(url);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    },
};
</script>
<style lang="scss" scoped>
.support-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 20px;
    
    .page-header {
        text-align: center;
        margin-bottom: 60px;
        animation: fadeIn 1s ease;
        
        h2 {
            font-size: 2.2rem;
            font-weight: 600;
            color: #2c3e50;
            margin-bottom: 15px;
        }
        
        .underline {
            width: 80px;
            height: 3px;
            background: linear-gradient(to right, #3498db, #2980b9);
            margin: 0 auto;
        }
    }
    
    .download-section {
        animation: fadeInUp 0.8s ease;
        
        .product-category {
            margin-bottom: 40px;
            
            .category-header {
                margin-bottom: 25px;
                position: relative;
                
                h3 {
                    font-size: 1.8rem;
                    color: #2c3e50;
                    font-weight: 600;
                    padding-left: 15px;
                    position: relative;
                    
                    &::before {
                        content: '';
                        position: absolute;
                        left: 0;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 5px;
                        height: 70%;
                        background: #3498db;
                        border-radius: 3px;
                    }
                }
            }
            
            .file-grid {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
                gap: 25px;
                
                .file-card {
                    background: #fff;
                    border-radius: 10px;
                    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
                    padding: 25px;
                    transition: all 0.3s ease;
                    display: flex;
                    align-items: center;
                    
                    &:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
                    }
                    
                    .file-icon {
                        width: 50px;
                        height: 50px;
                        background: #f1f5f9;
                        border-radius: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-right: 20px;
                        
                        i {
                            font-size: 24px;
                            color: #3498db;
                        }
                    }
                    
                    .file-info {
                        flex: 1;
                        
                        .file-name {
                            font-size: 1rem;
                            font-weight: 500;
                            color: #2c3e50;
                            margin-bottom: 12px;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                            line-height: 1.4;
                        }
                        
                        .download-btn {
                            display: inline-flex;
                            align-items: center;
                            background: #3498db;
                            color: #fff;
                            border: none;
                            border-radius: 5px;
                            padding: 8px 16px;
                            font-size: 0.9rem;
                            cursor: pointer;
                            transition: all 0.3s ease;
                            
                            &:hover {
                                background: #2980b9;
                                transform: translateY(-2px);
                            }
                            
                            i {
                                margin-right: 8px;
                            }
                        }
                    }
                }
            }
        }
    }
    
    @keyframes fadeIn {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    
    @keyframes fadeInUp {
        0% {
            opacity: 0;
            transform: translateY(30px);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }
    
    @media (max-width: 768px) {
        padding: 30px 15px;
        
        .page-header {
            margin-bottom: 40px;
            
            h2 {
                font-size: 1.8rem;
            }
        }
        
        .download-section {
            .product-category {
                .category-header h3 {
                    font-size: 1.5rem;
                }
                
                .file-grid {
                    grid-template-columns: 1fr;
                    gap: 20px;
                }
            }
        }
    }
}
</style>
